const WorkOrder = {

    // FIELDS
    "premise": "Premise",
    "asset_service": "Asset Service",
    "job_card": "Job Card",
    "vendor_name": "Vendor Name",
    "assign_to": "Assign To",
    "assigned_by": "Assigned By",
    "assigned_at": "Assigned At",
    "assigned_remark": "Assigned Remark",
    "created_at": "Created At",
    "schedule_date": "Schedule Date",
    "vendor_code": "Vendor Code",
    "vendor_mobile": "Vendor Mobile",
    "vendor_email": "Vendor Email",
    "overview": "Overview",
    "vendor_assign": "Vendor & Assignment",
    "history": "History",
    "no_history": "No history available",
    "by": "By",
    "action": "Action",
    "date_time": "Date & Time",
    "job_card_status": "Job Card Status",
    "fdate": "From Date",
    "tdate": "To Date",
    "date": "Date",
    "remark": "Remark",
    "status": "Status",
    "search": "Search",

    "update_status_title": "Update Status",
    "update_status_text": "Select a new status for this work order",
    "remark_placeholder": "Enter remark (optional)",
    "error_status_required": "Select Status",
    "status_updated": "Work Order Status Updated Successfully",
    "assign_title": "Assign Work Order",
    "assign_text": "Select a user to assign this work order",
    "assigned_remark_placeholder": "Enter assigned remark (optional)",
    "error_assign_to": "Select Assign To",
    "assign_success": "Work Order Assigned Successfully",

    // PAGE HEADER
    "work_order": "Work Order",

    // ERROR
    "error_premise": "Select Premise",
    "error_asset_service": "Select Asset Service",
    "error_job_card": "Select Job Card",
    "error_vendor": "Select Vendor",
    "error_vendor_name": "Enter Vendor Name",
    "error_fdate": "Select From Date",
    "error_tdate": "Select To Date",
    "error_date": "Select Date",
    "error_remark": "Enter Remark",

    // TABLE HEADER
    "table_work_order_number": "WORK ORDER NO.",
    "table_premise": "PREMISE",
    "table_job_card": "JOB CARD",
    "table_asset_service": "ASSET SERVICE",
    "table_vendor_name": "VENDOR",
    "table_assign_to": "ASSIGN TO",
    "table_fdate": "FROM DATE",
    "table_tdate": "TO DATE",
    "table_date": "DATE",
    "table_status": "STATUS",
    "table_remark": "REMARK",

}

export default WorkOrder;
